import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

// eslint-disable-next-line @github-ui/github-monorepo/react-app-name -- These route configs are registered by @github-ui/repo.
export const repoRouteBuilder = DataRouterApplicationBuilder.create('repo')
